import { BaseComponent } from '../../../../components/BaseComponent';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Plus } from '../../../../components/Icon';
import { List } from '../../../../components/List';
import { Button } from '../../../../components/Buttons';
import { HBox } from '../../../../components/Box';
import { InvoiceSubjectListItem } from '../InvoiceSubjectListItem';
import { Modal, ModalControls } from '../../../../components/Modal';
import { InvoiceSubjectForm } from './InvoiceSubjectForm';
import { INVOICE_DIRECTIONS, INVOICE_SUBJECT_TYPES } from '../../constants';
import { formatCurrency } from '../../../../utils/string';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const NEW_SUBJECT = 'NEW_SUBJECT';

const STATE = {
  add: false,
  delete: null,
  showSubject: null,
  items: [],
};

const Container = styled.div`
  width: ${props => (props.direction === INVOICE_DIRECTIONS.INCOMING ? '100%' : props.outgoingDesignV2 ? '100%' : '')};
  border: ${props => props.outgoingDesignV2 && '0px solid #ddd'};
  border-radius: ${props => props.outgoingDesignV2 && '4px'};
  padding: ${props => props.outgoingDesignV2 && '8px'};
`;

class InvoiceSubjectContainerComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE, items: props.items ?? STATE.items });
  }

  get items() {
    return this.props.items;
  }

  onCloseDelete() {
    this.setState(prev => {
      return {
        ...prev,
        delete: false,
      };
    });
  }

  onClickAdd() {
    this.setState(prev => {
      return {
        ...prev,
        showSubject: NEW_SUBJECT,
      };
    });
  }

  onDeleteItem(id) {
    this.setState(prev => {
      return {
        ...prev,
        delete: id,
      };
    });
  }

  onClickItem(id) {
    this.updateState('showSubject', id);
  }

  onConfirmDeleteItem() {
    this.props.onDeleteSubject(this.state.delete);
    this.setState(prev => {
      return {
        ...prev,
        delete: false,
      };
    });
  }

  onCloseSubject() {
    this.updateState('showSubject', null);
  }

  onSaveSubject(subject) {
    this.updateState('showSubject', null);
    this.props.onSaveSubject(subject);
  }

  renderDeleteSubject() {
    if (!this.state.delete) return '';

    return (
      <ModalComponent title={this.lbl('confirm')} onClose={this.onCloseDelete.bind(this)}>
        <div>{this.lbl('invoice.subject.deleteMsg')}</div>
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent style="ButtonSoftEdit" onClick={this.onConfirmDeleteItem.bind(this)}>
            {this.lbl('ok')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.onCloseDelete.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderSubject() {
    if (!this.state.showSubject) return '';
    let subject = null;

    if (this.state.showSubject === NEW_SUBJECT) {
      subject = { notSaved: true, type: INVOICE_SUBJECT_TYPES.PRODUCT };
    } else {
      subject = this.items.find(item => item.id === this.state.showSubject);
    }

    return (
      <InvoiceSubjectForm
        outgoingDesignV2={this.props.outgoingDesignV2}
        subject={subject}
        onSaveSubject={this.onSaveSubject.bind(this)}
        onClose={this.onCloseSubject.bind(this)}
        direction={this.props.direction}
        incomingCompanyId={this.props.incomingCompanyId}
        outgoingCompanyId={this.props.outgoingCompanyId}
        vehicleId={this.props.vehicleId}
        isBrutoScenario={this.props.isBrutoScenario}
        vehiclePurpose={this.props.vehiclePurpose}
      />
    );
  }

  render() {
    return (
      <Container direction={this.props.direction} outgoingDesignV2={this.props.outgoingDesignV2}>
        <List>
          {this.items?.map(i => (
            <InvoiceSubjectListItem
              lbl={this.lbl}
              style={{ width: '100%', fontSize: '24px' }}
              key={i.id}
              subject={i}
              outgoingDesignV2={this.props.outgoingDesignV2}
              direction={this.props.direction}
              onClick={this.onClickItem.bind(this)}
              onDelete={this.onDeleteItem.bind(this)}
            />
          ))}
        </List>

        <Button onClick={this.onClickAdd.bind(this)}>
          <Plus />
          {this.lbl('add')}
        </Button>

        {this.props.outgoingDesignV2 && (
          <HBox style={{ width: '100%', fontSize: '18px' }}>
            <strong>{this.lbl('invoice.create.financialTotalAmount')}: &nbsp;</strong>
            <strong style={{ color: 'black' }}>{formatCurrency(this.props.totalAmount)}</strong>
          </HBox>
        )}
        {this.renderDeleteSubject()}
        {this.renderSubject()}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceSubjectContainer = compose(withConnect, withRouter)(InvoiceSubjectContainerComp);
